import type { IconProps } from '../types/IconProps.ts';
export const ColumnChart: IconProps = {
    name: 'ColumnChart',
    children: [
        `<path d="M3 3v17a1 1 0 0 0 1 1h17M8 17v-4M13 5v12M18 17V9" />`,
    ]
};